import SnackbarMount, { SnackbarMountProps } from "./SnackbarMount";

function SnackbarOnSave({
  duration,
  ...props
}: Omit<SnackbarMountProps, "variant">) {
  return (
    <SnackbarMount
      {...props}
      duration={duration}
      variant="success"
    />
  );
}

export default SnackbarOnSave;
